export const vertexShader = `
  void main() {
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

export const fragmentShader = `
  uniform float transition;
  uniform vec2 resolution;
  uniform sampler2D backgroundTexture;
    void main() {
    vec2 vUv = gl_FragCoord.xy / resolution;
    gl_FragColor = texture2D(backgroundTexture, vUv);
    gl_FragColor.a *= transition;
  }
`;
